import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBars,
  FaTimes,
  FaWhatsapp,
} from 'react-icons/fa';


const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
const [isNearFooter, setIsNearFooter] = useState(false);
useEffect(() => {
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
    setShowScrollButton(window.scrollY > 300);
  };

  window.addEventListener('scroll', handleScroll);

  // 👇 Footer detection
  const footer = document.getElementById('footer');

  const observer = new IntersectionObserver(
    ([entry]) => {
      setIsNearFooter(entry.isIntersecting);
    },
    { threshold: 0.1 }
  );

  if (footer) observer.observe(footer);

  return () => {
    window.removeEventListener('scroll', handleScroll);
    if (footer) observer.unobserve(footer);
  };
}, []);


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

const openWhatsApp = () => {
  const url = 'https://wa.me/923034935404?text=Hello%20StayIN%2C%20I%20would%20like%20to%20inquire%20about%20apartments';

  // 👉 WhatsApp open
  window.open(url, '_blank');

  // ✅ 👉 GOOGLE CONVERSION TRACKING
  setTimeout(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18044656656/ojOzCO_arZIcEJC4rpxD'
      });
    }
  }, 300);
};

  // Navigation items for SEO consistency
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Apartments', path: '/apartments' },
    { name: 'AboutUs', path: '/about-us', displayName: 'About Us' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
  ];

  return (
    <>
      {/* Organization Schema for Header */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "StayIN Centaurus Serviced Apartments",
            "url": "https://stayinhospitality.com/",
            "logo": "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773301516/WhatsApp_Image_2026-03-10_at_3.14.14_PM__2_-removebg-preview__1_-removebg-preview_hgjnpd.png",
            "telephone": "+923034935404",
            "email": "info@stayin.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Centaurus Complex, Jinnah Avenue",
              "addressLocality": "Islamabad",
              "addressCountry": "PK"
            },
            "sameAs": [
              "https://www.facebook.com/stayin",
              "https://www.instagram.com/stayin",
              "https://www.linkedin.com/company/stayin"
            ]
          })}
        </script>
      </Helmet>

      <header>
        {/* Fixed Header Container */}
        <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#000000f5] text-white' : 'bg-secondary'
          }`}>
          {/* Top Bar */}
          <div className={`text-white py-3 text-sm  ${isScrolled ? 'border-b border-white/40 hidden' : 'hidden md:block border-b border-white/10'}`}>
            <div className="container-custom">
              <div className="flex justify-between items-center">
                <div className="flex gap-6">
                  <span className="flex items-center gap-2">
                    <FaPhone className="text-[#c9a86c] text-xs" aria-hidden="true" />
                    <a 
                      href="tel:+923034935404" 
                      className={`hover:text-[#c9a86c] transition ${isScrolled ? '' : 'text-white'}`}
                      aria-label="Call StayIN Centaurus at +92 303 4935404"
                    >
                      923034935404
                    </a>
                  </span>
                  <span className="flex items-center gap-2">
                    <FaEnvelope className="text-[#c9a86c] text-xs" aria-hidden="true" />
                    <a 
                      href="mailto:info@stayinhospitality.com" 
                      className={`hover:text-[#c9a86c] transition ${isScrolled ? '' : 'text-white'}`}
                      aria-label="Email StayIN Centaurus at info@stayinhospitality.com"
                    >
                      info@stayinhospitality.com
                    </a>
                  </span>
                  <span className="flex items-center gap-2">
                    <FaMapMarkerAlt className="text-[#c9a86c] text-xs" aria-hidden="true" />
                    <span className={`${isScrolled ? '' : 'text-white'}`}>
                      Centaurus, Islamabad
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Main Header */}
          <div className={`transition-all duration-300 ${isScrolled ? 'py-3' : 'py-5'}`}>
            <div className="container-custom">
              <div className="flex justify-between items-center">
                {/* Logo */}
                <Link 
                  to="/" 
                  className="flex flex-col leading-tight group"
                  aria-label="StayIN Centaurus - Home"
                >
                  <img 
                    src="https://res.cloudinary.com/dgwnm39m7/image/upload/v1773301516/WhatsApp_Image_2026-03-10_at_3.14.14_PM__2_-removebg-preview__1_-removebg-preview_hgjnpd.png" 
                    alt="StayIN Centaurus - Luxury Serviced Apartments Islamabad Logo" 
                    className="w-24 h-auto transition-transform group-hover:scale-105" 
                  />
                  <span className={`text-[10px] mt-2 tracking-widest uppercase transition-colors ${isScrolled ? '' : 'text-white/90'}`}>
                    Centaurus Hotel Service Apartments
                  </span>
                </Link>

                {/* Desktop Navigation */}
                <nav className="hidden lg:block" aria-label="Main navigation">
                  <ul className="flex gap-8">
                    {navItems.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.path}
                          className={`font-medium transition-all relative group ${isScrolled ? '' : 'text-white'}`}
                          aria-label={`Navigate to ${item.displayName || item.name}`}
                        >
                          {item.displayName || item.name}
                          <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-[#c9a86c] transition-all group-hover:w-full duration-300" aria-hidden="true"></span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>

                {/* Right Actions */}
                <div className="flex items-center gap-4">
                  <Link
                    to="/contact"
                    className={`hidden md:block px-6 py-2.5 rounded-full font-medium transition-all duration-300 ${isScrolled
                        ? 'bg-[#c9a86c] text-white hover:bg-[#b38f5a]'
                        : 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1a2b3c]'
                      }`}
                    aria-label="Book your stay at StayIN Centaurus"
                  >
                    Book Now
                  </Link>

                  {/* Mobile Menu Button */}
                  <button
                    className="lg:hidden transition-colors"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isMobileMenuOpen}
                  >
                    {isMobileMenuOpen ? (
                      <FaTimes size={24} className={'text-[#1a2b3c]'} aria-hidden="true" />
                    ) : (
                      <FaBars size={24} className={'text-white'} aria-hidden="true" />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`lg:hidden fixed top-0 right-0 w-full sm:w-96 h-full bg-white shadow-2xl transform transition-transform duration-300 z-50 pt-24 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
          aria-label="Mobile navigation menu"
          aria-hidden={!isMobileMenuOpen}
        >
          <FaTimes  
            onClick={() => setIsMobileMenuOpen(false)}  
            size={24} 
            className={'text-[#1a2b3c] absolute top-10 right-10 cursor-pointer'} 
            aria-label="Close menu"
          />
          <nav className="px-8" aria-label="Mobile navigation">
            <ul className="flex flex-col gap-6">
              {navItems.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-[#1a2b3c] text-lg font-medium hover:text-[#c9a86c] transition block py-2"
                    onClick={() => setIsMobileMenuOpen(false)}
                    aria-label={`Navigate to ${item.displayName || item.name}`}
                  >
                    {item.displayName || item.name}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <Link
                to="/contact"
                className="bg-[#c9a86c] text-white px-6 py-2.5 rounded-full font-medium transition-all duration-300 hover:bg-[#b38f5a] text-center block"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Book your stay at StayIN Centaurus"
              >
                Book Now
              </Link>
            </div>
          </nav>
        </div>

        {/* Overlay */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu overlay"
            aria-hidden="true"
          />
        )}
        
        {/* Floating Action Buttons */}
       <div
  className={`fixed right-6 z-50 flex flex-col gap-3 transition-all duration-300 ${
    isNearFooter ? 'bottom-32' : 'bottom-6'
  }`}
>
          {/* WhatsApp Button - Always visible */}
          <button
            onClick={openWhatsApp}
            className="bg-[#25D366] text-white w-14 h-14 rounded-full shadow-lg hover:bg-[#20BA5C] transition-all duration-300 flex items-center justify-center group hover:scale-110 animate-pulse-slow"
            aria-label="Chat with StayIN on WhatsApp for inquiries and bookings"
          >
            <FaWhatsapp className="text-2xl" aria-hidden="true" />
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;